module.exports = __webpack_public_path__ + "img/i-share-mono.783dfd05.svg";